<template>
  <v-data-table
    :headers="headers"
    :items="webHooks"
    hide-default-footer
    :no-data-text="$t('webHooksNoData')"
    class="pb-2"
    dense
  >
    <template v-slot:item.extra="{ item }">
      <v-icon v-if="item.extra">mdi-radiobox-marked</v-icon>
      <v-icon v-else>mdi-radiobox-blank</v-icon>
    </template>
    <template v-slot:top>
      <v-card-title tile>
        {{ $t("webHooksTitle") }}
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" persistent max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon>
              <v-icon>mdi-plus-circle</v-icon>
            </v-btn>
          </template>
          <v-card tile>
            <v-card-title>
              <span class="headline">{{ webHooksDialogTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-text-field
                type="text"
                v-model="editedItem.url"
                :label="$t('webHooksUrl') + ' *'"
                dense
                class="mt-4"
                required
                :error-messages="webHooksUrlErrors"
                @input="$v.editedItem.url.$touch()"
                @blur="$v.editedItem.url.$touch()"
              ></v-text-field>
              <v-checkbox
                v-model="editedItem.extra"
                color="success"
                :label="$t('webHooksExtra')"
              >
              </v-checkbox>
              <small>* {{ $t("validation") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="close">{{
                $t("btnCancel")
              }}</v-btn>
              <v-btn
                color="green darken-1"
                text
                @click="save"
                :disabled="$v.$invalid"
                >{{ $t("btnSave") }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card tile>
            <v-card-title class="headline">{{
              $t("webHooksRemove")
            }}</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="closeDelete">{{
                $t("btnNo")
              }}</v-btn>
              <v-btn color="green darken-1" text @click="deleteItemConfirm">{{
                $t("btnYes")
              }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-title>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
      <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required, minValue } from "vuelidate/lib/validators";

export default {
  name: "webHooksTable",

  mixins: [validationMixin],

  data() {
    return {
      dialog: false,
      dialogDelete: false,
      webHooks: [],
      headers: [
        {
          text: this.$i18n.t("webHooksUrl"),
          align: "start",
          sortable: false,
          value: "url",
        },
        {
          text: this.$i18n.t("webHooksExtra"),
          align: "start",
          sortable: false,
          value: "extra",
        },
        {
          text: this.$i18n.t("webHooksManage"),
          align: "end",
          sortable: false,
          value: "actions",
        },
      ],
      editedIndex: -1,
      editedItem: {
        url: "",
        extra: false,
      },
      defaultItem: {
        url: "",
        extra: false,
      },
    };
  },

  validations: {
    editedItem: {
      url: {
        required,
      },
    },
  },

  computed: {
    webHooksDialogTitle() {
      return this.editedIndex === -1
        ? this.$i18n.t("webHooksAdd")
        : this.$i18n.t("webHooksChange");
    },
    webHooksUrlErrors() {
      const errors = [];
      if (!this.$v.editedItem.url.$dirty) return errors;
      !this.$v.editedItem.url.required &&
        errors.push(this.$i18n.t("validationRequired"));
      return errors;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  methods: {
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
      this.$v.$reset();
    },
    save() {
      if (this.editedIndex > -1) {
        // Object.assign(this.webHooks[this.editedIndex], this.editedItem)
        this.editWebHook(this.editedItem).then(() => {
          this.loadWebHooksList();
        });
      } else {
        // this.webHooks.push(this.editedItem)
        this.createWebHook(this.editedItem).then(() => {
          this.loadWebHooksList();
        });
      }
      this.close();
      this.$v.$reset();
    },
    editItem(item) {
      this.editedIndex = this.webHooks.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.webHooks.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      // this.webHooks.splice(this.editedIndex, 1)
      this.removeWebHook(this.editedItem).then(() => {
        this.loadWebHooksList();
      });
      this.closeDelete();
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    loadWebHooksList() {
      this.getWebHooks().then((response) => {
        this.webHooks = response.data;
      });
    },
    ...mapActions([
      "getWebHooks",
      "createWebHook",
      "editWebHook",
      "removeWebHook",
    ]),
  },

  mounted() {
    this.loadWebHooksList();
  },
};
</script>
